import React from 'react';

export default React.memo(function Title(props) {
    //props
    const title = props.title;

    return ( <label>{title}</label> );
})